import React from "react";
import HobbyCard from "./HobbyCard";

const HobbiesSection = () => {
    const hobbies = [
        { id: 1, title: "Traveling", icon: "explore", description: "I love exploring new destinations, cultures, and cuisines. Traveling not only inspires creativity but also broadens my perspective." },
        { id: 2, title: "Cycling", icon: "directions_bike", description: "Cycling allows me to stay active and energized while enjoying the beauty of the outdoors. It's a perfect balance of fitness and relaxation." },
        { id: 3, title: "Photography", icon: "photo_camera", description: "Through photography, I capture unique moments and stories. It trains my eye for detail, which enhances my design and creative work." },
        { id: 4, title: "Listening to Music", icon: "headset", description: "Music keeps me inspired and motivated. From calming melodies to energizing beats, it helps me focus and recharge during or after work." },
        { id: 5, title: "Learning New Skills", icon: "auto_stories", description: "I'm passionate about continuous learning-whether it's exploring new technologies, design tools, or creative skills to grow professionally." },
        { id: 6, title: "Gaming", icon: "sports_esports", description: "Gaming challenges my problem-solving and strategic thinking. It improves focus, quick decision-making, and creative logic." },
        { id: 7, title: "Composing Music", icon: "piano", description: "I enjoy experimenting with sounds and creating original music. Composing allows me to express emotions and creativity beyond code." },
        { id: 8, title: "Listening to Audiobooks", icon: "menu_book", description: "Audiobooks give me a chance to absorb knowledge while multitasking. They help me stay informed, motivated, and inspired." }
    ];

    return (
        <section 
            id="hobbies" 
            className="relative py-24 bg-white dark:bg-background-dark border-t border-gray-100 dark:border-gray-800 scroll-mt-20 overflow-hidden"
        >
            {/* Background Decoration - Subtle Glows */}
            <div className="absolute top-0 left-1/4 size-96 bg-primary/5 rounded-full blur-[120px] -z-10 animate-pulse"></div>
            <div className="absolute bottom-0 right-1/4 size-96 bg-secondary/5 rounded-full blur-[120px] -z-10"></div>

            <div className="w-[90%] mx-auto">
                {/* Section Header */}
                <div className="flex flex-col items-center text-center mb-20">
                    <div className="reveal inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest font-display mb-6">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                        </span>
                        Personal Pursuits
                    </div>
                    
                    <h2 className="reveal reveal-delay-1 text-4xl md:text-5xl font-bold text-[#0d121b] dark:text-white font-display tracking-tight mb-6">
                        Beyond the <span className="text-primary italic">Code</span>
                    </h2>
                    
                    <p className="reveal reveal-delay-2 max-w-2xl text-gray-500 dark:text-gray-400 text-lg leading-relaxed font-medium">
                        When I'm not architecting SaaS solutions or building marketplaces, I immerse myself in experiences that fuel my creativity and keep my perspective fresh.
                    </p>
                </div>

                {/* Grid Layout */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {hobbies.map((hobby, index) => (
                        <HobbyCard
                            key={hobby.id}
                            hobby={hobby}
                            index={index}
                            // This creates a staggered 1-2-3-4 loop for the animation reveal
                            delay={`reveal-delay-${(index % 4) + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HobbiesSection;